import React, { useState, useEffect } from 'react';
import { Button, Form, Tab, Tabs } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker';
import './DatePicker.css';
import Swal from 'sweetalert2';
import { getUser } from '../utils/auth';


function CreateNewTrainingForm() {
  const navigate = useNavigate();

  const loggedInUser = getUser();

  // Base API URL from environment variable
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [training, setTraining] = useState({
    referenceCode: '',
    title: '',
    description: '',
    dateRange: [new Date(), new Date()],
    startTime: '09:00',
    endTime: '17:00',
    location: '',
    max_seat:10,
    status: 'Scheduled',
    assignedTrainer: '',
    assignedTrainerId: '',
    cancelReason: ''
  });

  const [requiredDuration, setRequiredDuration] = useState(null); // Selected course's required hours, for display only
  const [courses, setCourses] = useState([]); // To store course list from the database
  const [trainers, setTrainers] = useState([]); // To store trainer list from the database
  const [key, setKey] = useState('details');

  // Fetch courses from the database
  useEffect(() => {
    fetch(`${API_BASE_URL}/courses/get_courses.php?status=published`, { credentials: 'include' })
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to fetch courses');
        }
        return response.json();
      })
      .then(data => {
        console.log('Courses data:', data); // Log the data to inspect the response
        if (Array.isArray(data)) {
          setCourses(data); // Ensure data is an array
        } else {
          console.error('Unexpected data format:', data);
          setCourses([]); // Fallback to an empty array if data is not valid
        }
      })
      .catch(error => console.error('Error fetching courses:', error));
  }, []);

  // Fetch trainers from the database
  useEffect(() => {
    fetch(`${API_BASE_URL}/users/get_users.php?status=active`, { credentials: 'include' })
      .then(response => response.json())
      .then(data => {
        if (Array.isArray(data)) {
          // A trainingadmin may personally act as a trainer for their own
          // vendor — get_users.php already scopes a trainingadmin session's
          // result to just their own vendor company, so including
          // trainingadmin rows here can't pull in another vendor's admins.
          // Other roles (admin/masteradmin) keep seeing trainer-only,
          // matching the previous behavior.
          setTrainers(data.filter(u => u.role === 'trainer' || (loggedInUser.role === 'trainingadmin' && u.role === 'trainingadmin')));
        } else {
          setTrainers([]);
        }
      })
      .catch(error => console.error('Error fetching trainers:', error));
  }, []);

  // Handle form changes
  const handleChange = e => {
    const { name, value } = e.target;
    setTraining(prevTraining => ({
      ...prevTraining,
      [name]: value
    }));

    // When referenceCode changes, populate title and description
    if (name === 'referenceCode') {
      console.log('Courses value:', value);
      console.log('Courses :', courses);
      
      const selectedCourse = courses.find(course => course.id == value);
      console.log('selectedCourse:', selectedCourse);
      if (selectedCourse) {
        setTraining(prevTraining => ({
          ...prevTraining,
          title: selectedCourse.title,
          description: selectedCourse.description
        }));
        setRequiredDuration(selectedCourse.duration);
      } else {
        setRequiredDuration(null);
      }
    }
  };

  const handleDateChange = (dates) => {
    const [start, end] = dates;
    setTraining(prevTraining => ({
      ...prevTraining,
      dateRange: [start, end]
    }));
  };

  const handleSave = () => {
    const formData = new FormData();
    Object.keys(training).forEach(key => {
      // Format dateRange as start and end dates
      if (key === 'dateRange') {
        console.log("daterange",training.dateRange);
        const [startDate, endDate] = training.dateRange;

        
        //console.log("startDate",startDate.toISOString().split('T')[0]);

        formData.append('startDate', startDate.toLocaleDateString('en-CA')); // Format as YYYY-MM-DD
        formData.append('endDate', endDate.toLocaleDateString('en-CA')); // Format as YYYY-MM-DD
        formData.append(key, training[key]);
      } else {
        formData.append(key, training[key]);
      }
    });
  
    console.log("formdata",formData);

    fetch(`${API_BASE_URL}/trainings/save_training.php`, {
      method: 'POST',
      credentials: 'include',
      body: formData,
    })
    .then(response => {
      const contentType = response.headers.get('content-type');
  
      // Log the status and response text for debugging
      console.log('Response Status:', response.status);
      
      // Attempt to read the response as text first
      return response.text().then((text) => {
        console.log('Raw Response:', text); // Log the raw response text
        
        if (!response.ok) {
          // If response is not ok, throw an error with the response text
          throw new Error(`Failed with status ${response.status}: ${text}`);
        }
  
        // If response is JSON, parse it
        if (contentType && contentType.includes('application/json')) {
          return JSON.parse(text); // Parse JSON manually
        } else {
          // Return the raw text if it's not JSON
          return text;
        }
      });
    })
    .then(data => {
      console.log("data",data);
      // Check if the response is JSON or plain text
      if (typeof data === 'string') {
        console.log('Non-JSON response:', data);
        Swal.fire({ icon: 'error', text: `Received non-JSON response: ${data}` });
      } else if (data.success) {
        navigate('/trainings');
      } else {
        console.error('PHP Error:', data.message || data.error); // Log PHP error to the console
        Swal.fire({ icon: 'error', text: `Failed to save training: ${data.message || data.error}` });
      }
    })
    .catch(error => {
      console.error('Error saving training:', error);
      Swal.fire({ icon: 'error', text: `Error: ${error.message}` });
    });
  };

  const handleCancel = () => {
    navigate('/trainings');
  };

  return (
    <div>
      <h2>Create New Training</h2>
      <Tabs activeKey={key} onSelect={(k) => setKey(k)} className="mb-3">
        <Tab eventKey="details" title="Training Details">
          <Form>
            <Form.Group controlId="referenceCode">
              <Form.Label>Course/Training Reference Code</Form.Label>
              <Form.Control as="select" name="referenceCode" value={training.referenceCode} onChange={handleChange}>
                <option value="">Select Course</option>
                {courses.map(course => (
                  <option key={course.id} value={course.id}>
                    {course.code}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>

            <Form.Group controlId="title">
              <Form.Label>Title</Form.Label>
              <Form.Control type="text" name="title" value={training.title} readOnly />
            </Form.Group>

            <Form.Group controlId="description">
              <Form.Label>Description</Form.Label>
              <Form.Control as="textarea" rows={3} name="description" value={training.description} readOnly />
            </Form.Group>

            {requiredDuration !== null && (
              <Form.Text className="d-block mb-2">
                This course requires at least {requiredDuration} hour(s) of training. The date range and daily time window below must cover at least that much.
              </Form.Text>
            )}

            <Form.Group controlId="dateRange">
              <Form.Label>Date</Form.Label>
              <DatePicker
                dateFormat="dd/MM/yyyy"
                onChange={handleDateChange}
                startDate={training.dateRange[0]}
                endDate={training.dateRange[1]}
                selectsRange
                
              />
            </Form.Group>

            <Form.Group controlId="timeRange">
              <Form.Label>Time </Form.Label>
              <div style={{ display: 'flex', gap: '10px' }}>
                <Form.Control
                  type="time"
                  name="startTime"
                  value={training.startTime}
                  onChange={handleChange}
                  style={{ width: '130px' }}
                />
                <span>to</span>
                <Form.Control
                  type="time"
                  name="endTime"
                  value={training.endTime}
                  onChange={handleChange}
                  style={{ width: '130px' }}
                />
              </div>
            </Form.Group>
            <Form.Group controlId="max_seat">
              <Form.Label>Maximum Seat</Form.Label>
              <Form.Control type="text" name="max_seat" value={training.max_seat} onChange={handleChange} />
            </Form.Group>

            <Form.Group controlId="location">
              <Form.Label>Location</Form.Label>
              <Form.Control type="text" name="location" value={training.location} onChange={handleChange} />
            </Form.Group>

            <Form.Group controlId="status">
              <Form.Label>Status</Form.Label>
              <Form.Control as="select" name="status" value={training.status} onChange={handleChange} className="width300">
                <option value="Scheduled">Scheduled</option>
                <option value="Canceled">Canceled</option>
                <option value="Postponed">Postponed</option>
                <option value="Completed">Completed</option>
              </Form.Control>
            </Form.Group>

            <Form.Group controlId="assignedTrainerId">
              <Form.Label>Assigned Trainer</Form.Label>
              <Form.Control
                as="select"
                name="assignedTrainerId"
                value={training.assignedTrainerId}
                onChange={e => {
                  const selectedTrainer = trainers.find(t => String(t.id) === e.target.value);
                  setTraining(prevTraining => ({
                    ...prevTraining,
                    assignedTrainerId: e.target.value,
                    assignedTrainer: selectedTrainer ? selectedTrainer.name : ''
                  }));
                }}
              >
                <option value="">Select Trainer</option>
                {trainers.map(trainer => (
                  <option key={trainer.id} value={trainer.id}>
                    {trainer.name}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>

            {(training.status === 'Canceled' || training.status === 'Postponed') && (
              <Form.Group controlId="cancelReason">
                <Form.Label>{training.status === 'Postponed' ? 'Postpone Reason' : 'Cancel Reason'}</Form.Label>
                <Form.Control as="textarea" rows={3} name="cancelReason" value={training.cancelReason} onChange={handleChange} required />
              </Form.Group>
            )}
          </Form>
        </Tab>

        <Tab eventKey="documents" title="Documents/Attachment">
          <p>Upload documents here...</p>
        </Tab>
      </Tabs>

      <Button variant="primary" className="mr-2" onClick={handleSave}>Save</Button>
      <Button variant="secondary" onClick={handleCancel}>Cancel</Button>
    </div>
  );
}

export default CreateNewTrainingForm;
